<p class="text-center mt-5">
  <small i18n>{{ model?.vatRegNo }} {{ model?.companyRegNo }} {{ model?.eoriNo }}</small>
</p>
